import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import closeIcon from "../components/Image/close.svg";
import ModalAddArtwork from "../components/ModalAddArtwork";
import ArtistServices from "../../based/services/ArtistServices";
import { Notify } from "../../based/Notify";
import { NOTIFY ,CONSTANTS} from "../../based/Constants";
import { ConfirmDialog } from "../../based/Dialog";
import {LayoutImage} from "../components/LayoutImage"
import HomeIcon from "../components/Image/Home.svg"
import Request from "../../based/Request";
import MultipleImages from "../../based/MultipleImages"
import { FolderType } from "./ArtworkDesktop";

const OBJShow = {
    id: -1,
};
const PAGING_ART = {
    pageSize: 1000000,
    pageNumber: 1,
    keyword: "",
};


const modelArtwork = {
    name: "",
    id: 0,
    url: "",
    isDelete: false,
    folderId: 0,
};

function ArtworkMobile() {
    const [isModal , setIsModal] = useState(false)
    const [dataFolder, setDataFolder] = useState([])
    const [activeItem, setActiveItem] = useState(-1)
    const [dataArtwork, setDataArtwork] = useState([])
    const [dataArt, setDataArt] = useState([])
    const [flexNumber, setFlexNumber] = useState([])
    const [loading, setLoading] = useState(false)
    const [isVideo, setIsVideo] = useState(false);

    const history = useHistory()
    useEffect(()=>{
        getDataFolder()
    },[])

    useEffect(() => {
        const promises = [];
        dataArtwork.forEach((item) => {
            const img = new Image();
            const promise = new Promise((resolve) => {
                img.onload = () => resolve({ id: item.id, width: img.width, height: img.height, orientation: img.width > img.height ? "horizontal" : "vertical" });
            });
            img.src = item.url;
            promises.push(promise);
        });
        Promise.all(promises).then((results) => {
            // Lưu width và height của mỗi hình ảnh vào một mảng mới
            const dimensions = results.map((result) => ({ id: result.id, width: result.width, height: result.height, orientation: result.orientation }));
            LayoutImages(dimensions);
        });
    }, [dataArtwork]);

    function LayoutImages(data) {
        setFlexNumber(LayoutImage(data));
    }

    const getDataFolder = async () => {
        setLoading(true);
        let [err, data] = await ArtistServices.GetFolderArtistAndArtworkByUser();
        if (!err && data && data.length > 0) {
            setDataFolder(data);
            setActiveItem(-1);
            setLoading(false);
        } else {
            setDataFolder([]);
            setActiveItem(-1);
            setLoading(false);
        }
    };

    const getArtworkByFolderId = async (folderId, handleRemove) => {
        setLoading(true);
        let [err, data] = await ArtistServices.GetArtworkByFolderId(folderId, PAGING_ART);
        if (!err && data && data.length > 0) {
            setDataArtwork(data);
            setLoading(false);
        } else {
            setDataArtwork([]);
            setLoading(false);
        }
        if(data && handleRemove){
            // await getDataFolder()
            // setActiveItem(folderId)
            let newDT = [...dataFolder]
            dataFolder.forEach((item,idx)=>{
                if(item.id == folderId){
                    newDT[idx].artworks = data
                    newDT[idx].quantityArtwork = data.length
                }
                
            })
            setDataFolder(newDT)
        }
    };
    useEffect(() => {
        let col = 2;
        if (activeItem != -1) {
            let idex;
            dataFolder.forEach((item, idx) => {
                if (item.id == activeItem) idex = idx;
            });
            const idx = col - (idex % col) + idex;
            setDataFolder((prevList) => [...prevList.slice(0, idx), OBJShow, ...prevList.slice(idx)]);
        } else {
            resetData();
        }
    }, [activeItem]);

    const resetData = () => {
        let datanew = dataFolder.filter((x) => x.id != -1);
        setDataFolder(datanew);
    };

    const render = () => {
        return dataFolder.map((item, i) => {
            if (item.id == -1) {
                return renderArtwork();
            } else
                return (
                    <div key={i} className={`col ${activeItem == item.id ? "active" : ""}`}>
                        <div
                            className="item"
                            onClick={() => {
                                setIsVideo(item.folderType == FolderType.Video);
                                resetData();
                                if (activeItem == item.id) {
                                    setActiveItem(-1);
                                    setDataArtwork([]);
                                } else {
                                    setDataArtwork([]);
                                    getArtworkByFolderId(item.id, false);
                                    setActiveItem(item.id);
                                }
                            }}
                        >
                            <div className="show">
                                {item.artworks.length > 0 ? (
                                    item.artworks.length >= 2 ? (
                                        <div className="image">
                                            <div className="item-image">
                                                {item.folderType == FolderType.Video ? (
                                                    <video>
                                                        <source src={item.artworks[0].url} type="video/mp4" />
                                                    </video>
                                                ) : (
                                                    <img src={item.artworks[0].url} alt="alt" />
                                                )}
                                            </div>
                                            <div className="item-image">
                                                {item.folderType == FolderType.Video ? (
                                                    <video>
                                                        <source src={item.artworks[1].url} type="video/mp4" />
                                                    </video>
                                                ) : (
                                                    <img src={item.artworks[1].url} alt="alt" />
                                                )}
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="image">
                                            <div className="item-image">
                                            {item.folderType == FolderType.Video ? (
                                                    <video>
                                                        <source src={item.artworks[0].url} type="video/mp4" />
                                                    </video>
                                                ) : (
                                                    <img src={item.artworks[0].url} alt="alt" />
                                                )}
                                            </div>
                                        </div>
                                    )
                                ) : (
                                    <div className="image">
                                        <div className="item-image no-image"></div>
                                        <div className="item-image no-image"></div>
                                    </div>
                                )}
                                <div className="desc">{item.name}</div>
                                <div className="quantity">{item.quantityArtwork}</div>
                            </div>
                        </div>
                    </div>
                );
        });
    };

    function findWidth(id) {
        let item = flexNumber.filter((itm) => itm.id === id);
        return item[0] && item[0].flexNumber;
    }

    function renderArtwork() {
        return (
            <div className="list-artwork">
                <div className="list-art">
                    <div className="row-art">
                        {dataArtwork && dataArtwork.length > 0 ? (
                            dataArtwork.map((item, idx) => {
                                return <ArtworkItem flexNumber={findWidth(item.id)} item={item} getArtworkByFolderId={getArtworkByFolderId} folderId={activeItem} idx={idx} isVideo={isVideo}  />;
                            })
                        ) : (
                            <div className="no-artwork">
                                <div className="artwork-zero">
                                    <div className="box"></div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }



    async function handleChange(value) {
        let data = []
        if(value && value.length > 0){
            value.map((img) => {
                var existed = dataArt.find((x) => x.url == img);
                if(!existed){
                    var item = {
                        ...modelArtwork,
                        url: img,
                        thumbnail: img,
                    }
                    data.push(item)
                }
            })
        }
        await setDataArt([...dataArt,...data]);
        openModal()
        
        
    }


    function openModal(){
        setIsModal(true)
    }


    return (
        <ArtworkMobileStyle>
            <div className="art-work-main">
                <div className="title-artist">
                    <img src={HomeIcon} about="Home" onClick={()=>{
                    history.push("/")
                }}/>
                    <h2>Artwork</h2>
                </div>
                <span className="desc">Folder</span>
                <div className="list-folder">
                    {render()}
                    {dataFolder.length == 0 && <span className="desc-nofolder">Chưa có folder , liên hệ với Ranus để được tạo folder nhé !</span>}
                </div>

            </div>
            {dataFolder.length > 0 && (
                <div className="footer-artwork">
                    <MultipleImages className="hide" id="art-work-mobile" name="art-mobile" size={20} images={[]} onChanged={(key, value) => handleChange(value)} />
                    <label
                        for="art-work-mobile"
                        
                    >
                        {activeItem == -1 ? "Tải lên" : "Thêm artwork"}
                    </label>
                </div>
            )}
            <ModalAddArtwork setDataArt={setDataArt} dataArt={dataArt} isModal={isModal} folderId={isVideo ? -1 : activeItem} setIsModal={setIsModal} getDataFolder={getDataFolder} />
        </ArtworkMobileStyle>
    );
}

function ArtworkItem({ item, getArtworkByFolderId, folderId, flexNumber, idx, isVideo }) {
    function handleDeleteArtwork() {
        const ids = [];
        ids.push(item.id);
        ConfirmDialog("Xác nhận xóa?", "Bạn có chắc chắn muốn xóa artwork này?", () => {
            return new Promise(async (resolve, reject) => {
                let [err, data] = await ArtistServices.DeteleFolderArtistCon(ids, folderId);
                if (!err && data) {
                    getArtworkByFolderId(folderId, true);
                    resolve({ title: "Thành công", msg: "Xóa thành công." });
                } else {
                }
            });
        });
    }
    if (isVideo)
        return (
            <div className="item-art video">
                <video controls>
                    <source src={item.url} type="video/mp4" />
                </video>
            </div>
        );
    return (
        <div key={idx} style={{ width: `calc(${flexNumber}% - 10px` }} className="item-art">
            <img src={item.url} />
            <div className="remove-art" onClick={handleDeleteArtwork}>
                <img src={closeIcon} alt="remove" />
            </div>
        </div>
    );
}
const ArtworkMobileStyle = styled.div`
    width: 100%;
    background-color: #313131;
    min-height: 100svh;
    scroll-behavior: smooth;

    .ml-18 {
        margin-left: 18px;
    }
    .hide{
        display: none;
    }
    .art-work-main {
        padding: 16px;
        margin-bottom: 78px;

        .desc {
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
            color: #ffffff;
            margin-top: 29px;
            display: block;
        }
        .desc-nofolder {
            font-weight: 500;
            font-size: 16px;
            line-height: 20px;
            color: #06f1b9;
            margin-top: 10px;
            display: block;
        }

        .list-folder {
            margin: 20px -6px 0;
            display: flex;
            flex-wrap: wrap;

            .list-artwork {
                padding: 0 6px;
                flex-basis: 100%;
                margin-bottom: 10px;
                min-width: 100%;
                max-width: 100%;
                margin-top: -12px;

                .list-art {
                    background-color: #464646;
                    border-radius: 0 0 10px 10px;
                    border: 2px solid #06f1b9;

                    .row-art {
                        display: flex;
                        flex-wrap: wrap;

                        .no-artwork {
                            .artwork-zero {
                                width: 100%;
                                height: 120px;
                            }
                        }

                        .item-art {
                            position: relative;
                            margin: 5px;
                            height: auto;
                            min-height: 50px;

                            &.video{
                                width: 50%;
                                min-width: 50%;
                                max-width: 50%;
                                padding: 7px;
                                margin: 0;

                                video{
                                    width: 100%;
                                    height: auto;
                                }
                            }

                            img {
                                border-radius: 5px;
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                            .remove-art {
                                position: absolute;
                                top: 5px;
                                right: 5px;
                                cursor: pointer;

                                img {
                                    width: 20px;
                                    height: 20px;
                                    object-fit: contain;
                                }
                            }
                        }
                    }
                }
            }





            .col{
                padding: 0 6px;
                flex-basis: 50%;
                margin-bottom: 10px;
                min-width: 50%;
                max-width: 50%;
    
                &.active{
                    .item{
                        border-radius: 10px 10px 0 0;
                        border-top: 2px solid;
                        border-left: 2px solid;
                        border-right: 2px solid;
                        border-color: #06F1B9;
                        padding-bottom: 12px;
                    }
                }
               
    
                .item{
                    width: 100%;
                    border-radius: 10px;
                    background-color: #464646;
                    cursor: pointer;
    
                    .show{
                        padding: 10px;
            
                        .image{
                            display: flex;
                            justify-content: space-between;
                            width: 100%;

                            
    
                            .item-image{
                                width: calc(50% - 5px);
                                aspect-ratio: 1/1;
                                line-height: 1;
                                
                                &.no-image{
                                    aspect-ratio: 1/1;
                                }

                                img{
                                    width: 100%;
                                    aspect-ratio: 1/1;
                                    object-fit: contain;
                
                                }

                                video {
                                    width: 100%;
                                    aspect-ratio: 1/1;
                                    border-radius: 5px;
                                }
                            }
                            
                        }
                        
                        .desc{
                            margin-top: 10px;
                            font-weight: 500;
                            font-size: 14px;
                            line-height: 18px;
                            letter-spacing: -0.3px;
                            color: #FFFFFF;
                        }
                        .quantity{
                            font-weight: 500;
                            font-size: 12px;
                            line-height: 15px;
                            letter-spacing: -0.3px;
                            color: #9A9A9A;
    
                        }
                    }
                }
            }
            .col{
                padding: 0 6px;
                flex-basis: 50%;
                margin-bottom: 10px;
                min-width: 50%;
                max-width: 50%;
    
                &.active{
                    .item{
                        border-radius: 10px 10px 0 0;
                        border-top: 2px solid;
                        border-left: 2px solid;
                        border-right: 2px solid;
                        border-color: #06F1B9;
                        padding-bottom: 12px;
                    }
                }
               
    
                .item{
                    width: 100%;
                    border-radius: 10px;
                    background-color: #464646;
                    cursor: pointer;
    
                    .show{
                        padding: 10px;
            
                        .image{
                            display: flex;
                            justify-content: space-between;
                            width: 100%;

                            
    
                            .item-image{
                                width: calc(50% - 5px);
    
                                &.no-image{
                                    aspect-ratio: 1/1;
                                }

                                img{
                                    width: 100%;
                                    aspect-ratio: 1/1;
                                    object-fit: contain;
                
                                }
                            }
                            
                        }
                        
                        .desc{
                            margin-top: 10px;
                            font-weight: 500;
                            font-size: 14px;
                            line-height: 18px;
                            letter-spacing: -0.3px;
                            color: #FFFFFF;
                        }
                        .quantity{
                            font-weight: 500;
                            font-size: 12px;
                            line-height: 15px;
                            letter-spacing: -0.3px;
                            color: #9A9A9A;
    
                        }
                    }
                }
            }












        }
        
    
        .title-artist{
            display: flex;
            align-items: center;

            img{
                width: 25px;
                height: 25px;
            }
            h2{
                margin-left: 15px;
                font-weight: 600;
                font-size: 25px;
                line-height: 31px;
                letter-spacing: -0.3px;
                color: #FFFFFF;
                margin-bottom: 0;
            }
        }
    }

    
    .footer-artwork {
        position: fixed;
        bottom: 0;
        width: 100%;
        display: grid;
        place-items: center;
        padding: 16px;
        background: #313131;
        box-shadow: 0px -0.2px 1px #646464, 0px -2px 20px rgba(0, 0, 0, 0.15);

        label {
            display: block;
            width: 100%;
            height: 46px;
            background: linear-gradient(259.14deg, #06f1b9 1.32%, #008263 100%);
            border-radius: 10px;
            display: grid;
            place-items: center;
            font-weight: 600;
            font-size: 18px;
            line-height: 20px;
            letter-spacing: -0.3px;
            color: #ffffff;
            border: none;
            outline: none;
        }
    }
`;
export default ArtworkMobile;



// WEBPACK FOOTER //
// ./src/artist-ui/Artwork/ArtworkMobile.js